import {Link} from "react-router-dom";
import HiWb from "../../../assets/images/hiw-b.svg";
import HiWc from "../../../assets/images/hiw-c.svg";
import "./PersonalizedLinkBanner.scss";


const PersonalizedLinkBanner = (args) => {

     // 
     const {
          isDark = false
     } = args;

     //
     return (
          isDark?
          <>
               <div className="final-banner">

                    <div className="final-banner-left">
                         <div className="final-banner-title">
                              Find the best credit card for you
                         </div>

                         <div className="final-banner-text">
                              Just answer a few questions and we'll narrow the search for you.
                         </div>

                         <Link to={`/find-best-card-for-your-spend`}>
                              <button className="btn luci-btn white-btn ga-recsFlowClick ga-recsFlowClick-section2" style={{whiteSpace: "nowrap", fontSize: "16px"}}>
                                   Find Your Card &rarr;
                              </button>
                         </Link>
                    </div>

                    <div className="final-banner-img-container">
                         <img src={HiWc} alt=""/>
                    </div>

                    <div className="final-banner-circle-fill"></div>
               </div>                    
          </>
          :
          <>
               <div className="link-banner">
                    <div className="link-banner-left">
                         <div className="link-banner-title">
                              Find the best credit card for you
                         </div>

                         <div className="link-banner-text">
                              If you are looking for a credit card that earns the most rewards for your spend, we got you covered.
                         </div>

                         <Link to={`/find-best-card-for-your-spend`}>
                              <button className="btn luci-btn white-btn ga-recsFlowClick ga-recsFlowClick-section1" style={{whiteSpace: "nowrap", fontSize: "16px"}}>
                                  Find Your Card &rarr;
                              </button>
                         </Link>
                    </div>

                    <div className="link-banner-img-container">
                         <img src={HiWb} alt=""/>
                    </div>

                    <div className="link-banner-circle-fill"></div>
               </div>
          </>

     );

}

export default PersonalizedLinkBanner;